import styled from "@emotion/styled";

export const Project = styled.div`
  margin: 0;
  padding: 10px;
  width: 300px;
  border: 1px solid black;

`;

export const Title = styled.h2`
margin: 0;
`;

export const MakePositionsUL = styled.ul`
position: absolute;
margin: 0;
padding: 0;
display: flex;

`

export const MakePositionsLI = styled.li`
margin: 0;
margin-right: 5px;
`;

export const Img = styled.img`
display: block;
margin: auto;
margin-top: 20px;
width: 250px;
height: 250px;
`;

export const TechnologiesUL = styled.ul`
margin: 0;
margin-top: 10px;
padding: 0;
display: flex;
flex-wrap: wrap;
justify-content: flex-start;

`;

export const TechnologiesLI = styled.li`
margin: 0;
margin: 0px 5px 5px;
padding: 3px 5px 3px 5px;
border: 1px solid black;
`;

export const Describe = styled.p`
margin: 0;
`;

export const LinksGitSite = styled.ul`
margin: 0;
padding: 0;
display: flex;
justify-content: space-around
`;

export const LinkGit = styled.a`
margin: 0;
`;

export const LinkSite = styled.a`
margin: 0;

`;

